import { Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import React from "react";
import CustomDraggableDialog from "../../common/customDialog/CustomDraggableDialog";
import TranslatedMessage from "../../translations/TranslatedMessage";

type SelfCancelDialogProps = {
  onAccept: () => void;
  onDecline: () => void;
  isCancelDialogOpen: boolean;
};

const SelfCancelDialog: React.FunctionComponent<SelfCancelDialogProps> = ({
  onAccept,
  onDecline,
  isCancelDialogOpen,
}) => {
  return (
      <CustomDraggableDialog
        acceptText={<TranslatedMessage id="common.accept" />}
        cancelText={<TranslatedMessage id="common.cancel" />}
        content={
          <React.Fragment>
            <FormControl component="fieldset">
              <Typography>
                <TranslatedMessage id="selfcancellation.text" />
              </Typography>
            </FormControl>
          </React.Fragment>
        }
        isOpen={isCancelDialogOpen}
        onAccept={onAccept}
        onCancel={onDecline}
        title={<TranslatedMessage id="selfcancellation.header" />}
      />
  );
};

export default SelfCancelDialog;
